module.exports = __webpack_public_path__ + "static/img/09007D_R_2_3_4_5_6_20180224_LC.fdac893.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/09007D_R_2_3_4_5_6_20180224_LC.png
// module id = 1UbY
// module chunks = 0